module.exports = __webpack_public_path__ + "static/img/bigdata.3b4f037b.png";